import type { ReactNode } from "react";
import { FreyrComponentLibraryProvider as RimsFreyrComponentLibraryProvider } from "@freyr/freyr-react-common-components-rims";

type EnvVarKeys = "IM_PREFIX" | "URF_PREFIX";

export type UnifiedFreyrComponentProvidersProps = {
  children: ReactNode;
  language?: string;
  token?: string;
  tenant?: string;
  domain?: string;
  domainName?: string;
  envVars?: Partial<Record<EnvVarKeys, string>>;
  useEmail?: string;
  moduleName?: string;
  userInfo?: string;
};

const UnifiedFreyrComponentProviders = (
  props: UnifiedFreyrComponentProvidersProps,
) => {
  const { children, ...providerProps } = props;

  return (
    <RimsFreyrComponentLibraryProvider {...providerProps}>
      {children}
    </RimsFreyrComponentLibraryProvider>
  );
};

export default UnifiedFreyrComponentProviders;
